import React, { createContext, useContext, useMemo, useState } from 'react';
import { translate } from '../locales/messages';

const STORAGE_KEY = 'hkshk_lang';
const LanguageContext = createContext(null);

function readLang() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'en' ? 'en' : 'zh-Hant';
  } catch (error) {
    return 'zh-Hant';
  }
}

function applyLang(lang) {
  document.documentElement.lang = lang === 'en' ? 'en' : 'zh-Hant';
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const initial = readLang();
    applyLang(initial);
    return initial;
  });

  const value = useMemo(() => {
    const setLang = (next) => {
      const stored = next === 'en' ? 'en' : 'zh-Hant';
      localStorage.setItem(STORAGE_KEY, stored);
      applyLang(stored);
      setLangState(stored);
    };
    const t = (key, vars) => translate(lang, key, vars);
    const formatDate = (value, options) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return date.toLocaleDateString(lang === 'en' ? 'en-HK' : 'zh-HK', options);
    };
    const formatDateTime = (value) => {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return date.toLocaleString(lang === 'en' ? 'en-HK' : 'zh-HK');
    };
    return { lang, setLang, t, formatDate, formatDateTime };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
}

export function LanguageToggle() {
  const { lang, setLang, t } = useLanguage();
  return (
    <div className="lang-toggle" role="group" aria-label={t('lang.switch')}>
      <button type="button" className={lang === 'zh-Hant' ? 'active' : ''} onClick={() => setLang('zh-Hant')}>繁中</button>
      <span aria-hidden="true">|</span>
      <button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')}>EN</button>
    </div>
  );
}
